import { UPI_STATUS_POLL_REQUEST, UPI_STATUS_POLL_SUCCESS, UPI_STATUS_POLL_ERROR, UPI_STATUS_POLL_TIMEOUT_ERROR } from 'actions/PaymentActions/PaymentActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
export const INITIAL_STATE = {
    asyncStatus: INIT
};
export default function upiPollState(state = INITIAL_STATE, action) {
    switch (action.type) {
        case UPI_STATUS_POLL_REQUEST:
            return Object.assign({}, state, { asyncStatus: LOADING, timedOut: false });
        case UPI_STATUS_POLL_ERROR:
            return Object.assign({}, state, Object.assign({ asyncStatus: ERROR }, action.error));
        case UPI_STATUS_POLL_SUCCESS:
            return Object.assign({}, state, Object.assign({ asyncStatus: SUCCESS }, action.data));
        case UPI_STATUS_POLL_TIMEOUT_ERROR:
            return Object.assign({}, state, { asyncStatus: SUCCESS, timedOut: true });
        default:
            return state;
    }
}
